import React from 'react'
import Route from '../router/Route'
import WorkItem from './WorkItem'
import {connect} from 'react-redux'

class WorkRoutes extends React.Component {

  constructor(props){

    super(props)



  }

  shouldComponentUpdate(){

    return true;
  }

  render () {

    //console.log(this);

    //return (<div>Hello</div>)

    return(

          <div>

                {

                  this.props.workData.data.map((item,index)=>{
                    return (<Route key={'wi'+index} exact path={'/work/'+item.slug} >
                                <WorkItem path={'/work/'+item.slug}  />
                            </Route>
                    )
                  })
                }


            </div>


    )
  }
}

const mapStateToProps = (state) => {
    const workData = state.KastnerStore.workData
    return{
      workData
    }
}

export default connect(mapStateToProps)(WorkRoutes);



// WEBPACK FOOTER //
// ./src/modules/work/WorkRoutes.js